import { render } from "./BlogFullMouthRestLongevity.vue?vue&type=template&id=8c66a914"
import script from "./BlogFullMouthRestLongevity.vue?vue&type=script&lang=js"
export * from "./BlogFullMouthRestLongevity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__